import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=71d20d3e&lang=pug&"
import script from "./SupplierList.vue?vue&type=script&lang=ts&"
export * from "./SupplierList.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierList.vue?vue&type=style&index=0&id=71d20d3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports